export const onKeyboardClosed = (callback: Function) => {
    window.RahmetWebApp.onKeyboardClosed = callback;
};
